import { Component, Input, Optional } from '@angular/core'
import { IcosTree } from './tree'
import { IcosTreeModelData } from './tree-props'
import { dropAnimation } from '../shared/animation'

@Component({
  selector: 'icos-tree-item',
  animations: [dropAnimation],

  template: `
    <div
      class="icos-tree-node"
      (click)="clickHandle($event)"
      [class.is-focusable]="!root.icosDisabled"
      [class.is-checked]="!root.icosDisabled && model.checked"
      role="treeitem"
    >
      <div class="icos-tree-node__content" [ngStyle]="{ 'padding-left': (model._level - 1) * indent + 'px' }">
        <span
          class="icos-tree-node__expand-icon icos-icon-caret-right"
          [class.expanded]="model.expanded"
          [class.is-leaf]="isLeaf()"
          (click)="iconClickHandle($event)"
        ></span>
        <icos-checkbox
          *ngIf="root.showCheckbox"
          [model]="model.checked"
          [indeterminate]="model._indeterminate"
          [icosDisabled]="root.icosDisabled"
          (modelChange)="checkHandle($event)"
        >
        </icos-checkbox>
        <span class="icos-tree-node__label">{{ model.label }}</span>
      </div>
      <div class="icos-tree-node__children" *ngIf="!isLeaf()" [@dropAnimation]="model.expanded">
        <icos-tree-item *ngFor="let item of model.children" [model]="item" [indent]="indent"> </icos-tree-item>
      </div>
    </div>
  `
})
export class IcosTreeItem {
  @Input() indent: number
  @Input() model: IcosTreeModelData

  constructor(@Optional() public root: IcosTree) {}

  clickHandle(event: MouseEvent): void {
    event.stopPropagation()
    if (!this.root.expandOnClickNode) return this.itemEmitter('click')
    this.updateExpanded()
  }

  iconClickHandle(event: MouseEvent): void {
    event.stopPropagation()
    this.updateExpanded()
  }

  checkHandle(event): void {
    if (this.root.icosDisabled) return
    this.root.updateChecked(this.model.id)
    this.root.emitter({
      label: this.model.label,
      treeNodeID: this.model.id,
      action: 'checkbox',
      checked: this.model.checked
    })
  }

  updateExpanded(): void {
    const dontUpdateExpanded: boolean = this.isLeaf()
    const nextAction: string = dontUpdateExpanded ? 'click' : this.model.expanded ? 'close' : 'open'
    this.itemEmitter(nextAction)
    !dontUpdateExpanded && this.root.updateExpanded(this.model.id)
  }

  isLeaf(): boolean {
    return !this.model.children || !this.model.children.length
  }

  itemEmitter(action: string): void {
    this.root.emitter({
      label: this.model.label,
      treeNodeID: this.model.id,
      action,
      checked: this.model.checked
    })
  }
}
